import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'Thankyou.ItemsOnTheirWay.title',
    description: 'ItemsOnTheirWay title',
    defaultMessage: 'Items on Their Way',
  },
});
